import React from 'react';

import { EuiImage } from '../../../../src/components';

export default () => (
  <EuiImage
    size="l"
    width={600}
    hasShadow
    caption="Diagram of fishapod timelines"
    alt="Diagram of fishapod timelines"
    src="https://upload.wikimedia.org/wikipedia/commons/a/af/Fishapods.svg"
    allowFullScreen
  />
);
